export type GroupDim = 'location' | 'specialty' | 'microphone' | 'template';

export const GROUP_DIMS: GroupDim[] = [
  'location',
  'specialty',
  'microphone',
  'template',
];

export const GROUP_DIM_LABELS: Record<GroupDim, string> = {
  location: 'Location',
  specialty: 'Specialty',
  microphone: 'Microphone',
  template: 'Template Bundle',
};
